<template>
    <div>

        <div class="modal fade" id="planningTransportEventBoxModal" tabindex="-1" aria-labelledby="planningTransportEventBoxModal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="px-4 py-2">
                        <div class="modal-icon text-center mt-2">
                            <span class="round-icon bg-lightyellow">
                                <i class="fa fa-bell text-primary" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="modal-body">
                            <h3 class="mb-2 text-primary text-center">Transport gegevens</h3>
                            <table style="width: 100%;">
                                <tr>
                                    <td style="width: 35%;" class="strong">Type vervoer</td>
                                    <td style="width: 65%;" class="strong">{{ this.item.vehicle_title }}</td>
                                </tr>
                                <tr>
                                    <td style="width: 35%;" class="strong">Naam</td>
                                    <td style="width: 65%;" class="strong">{{ this.item.title }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Adres</td>
                                    <td>{{ this.item.address }} {{ this.item.number }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Postcode</td>
                                    <td>{{ this.item.zip_code }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Plaats</td>
                                    <td>{{ this.item.city }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Datum</td>
                                    <td>{{ this.item.date }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Tijd</td>
                                    <td>{{ this.item.start_time }} - {{ this.item.end_time }}</td>
                                </tr>
                            </table>

                            <div class="modal-body pt-4 px-4 pb-4 d-flex">
                                <a :href="this.item.order_url" class="btn btn-primary ms-auto px-3 py-2 text-sm">
                                    Bekijk opdracht
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {EventBus} from "../../../event-bus";

    export default {
        name: 'planning-transport-modal',
        components: {},
        props: {},
        data() {
            return {
                item: {
                    type: null,
                    vehicle_id: null,
                    type_id: null,
                    date: null,
                    start_time: null,
                    end_time: null,
                    start_date: null,
                    end_date: null,
                    order_url: null,
                    note: null,
                }
            }
        },
        computed: {},
        watch: {},
        methods: {},
        mounted() {

            this.planningTransportEventBoxModal = new bootstrap.Modal(document.getElementById('planningTransportEventBoxModal'));

            EventBus.$on('showPlanningTransportEvent', (item) => {
                this.item = item;
                this.planningTransportEventBoxModal.show();
            });
        },
        created() {},
    }
</script>

<style scoped>
    td {
        vertical-align: top;
    }
    .fc-event{
        cursor: pointer;
    }
</style>
